import type { LoyaltyMemberBase } from '~/hooks/apis/reporting/useLoyaltyAnalytics';

import type { LoyaltyMetric } from './types';

const NUMBER = { kind: 'number' } as const;
const CELL = {
  comparisonValue: null,
  absoluteChange: null,
  percentChange: null,
  favourableDirection: 'contextual',
  programme: 'societe',
  state: 'draft',
  source: { catalogueId: 'loyalty_member_base' },
} as const;

const FALLBACK_PRIMARY_COUNT = 6;

/** Splits metrics by the server's group. Without any group, the first six lead and the rest support. */
export function splitMetricGroups(metrics: ReadonlyArray<LoyaltyMetric>) {
  if (metrics.some((metric) => metric.group)) {
    return {
      primary: metrics.filter((metric) => metric.group !== 'supporting'),
      supporting: metrics.filter((metric) => metric.group === 'supporting'),
    };
  }
  return { primary: metrics.slice(0, FALLBACK_PRIMARY_COUNT), supporting: metrics.slice(FALLBACK_PRIMARY_COUNT) };
}

/** The member base as KPI cells. Counts as at the latest build carry no comparison and no sparkline. */
export function memberBaseMetrics(base: LoyaltyMemberBase): Array<LoyaltyMetric> {
  const cell = (id: string, label: string, value: number, definition: string): LoyaltyMetric => ({
    ...CELL,
    id: `loyalty.base.${id}`,
    label,
    definition,
    format: NUMBER,
    value,
  });
  return [
    cell('members', 'Members', base.members, 'Société members in the latest daily build, excluding cancelled members.'),
    cell(
      'active',
      'Active members',
      base.activeMembers,
      'Members who earned points in the last 12 months, as at the latest daily build.',
    ),
    cell(
      'points',
      'Points outstanding',
      base.pointsOutstanding,
      'Points held by members and not yet burned or expired.',
    ),
    cell(
      'credits',
      'Status credits due',
      base.statusCreditsOutstanding,
      'Status credits outstanding: held by members toward their tier.',
    ),
  ];
}
